export default [
  {
    title: '전남드래곤즈 이용약관 동의 (필수)',
    desc : `
<pre>
제1조 목적


1. 본 약관은 주식회사 전남드래곤즈(이하 "회사"라 합니다)가 홈페이지(www.dragons.co.kr)를 (이하 "사이트"라 합니다) 통하여 제공하는 인터넷 관련 서비스(이하 "서비스"라 합니다)를 이용함에 있어 이용자와 "회사"의 권리·의무 및 책임사항을 규정함을 목적으로 합니다.

2. 본 약관에 정하는 이외의 "이용자"와 "회사"의 권리, 의무 및 책임사항에 관해서는 전기통신사업법 기타 대한민국의 관련 법령과 상관습에 의합니다.


제2조 이용자의 정의


1. "이용자"란 "사이트"에 접속하여 "회사"가 제공하는 서비스를 받는 자를 말하며 이는 "회원"과 "비회원"으로 구분됩니다.

2. "회원"이란 "사이트" 내에서 일정의 가입 절차를 거쳐 개인정보를 제공하고 등록을 마친 자로서 "사이트"를 통해 제공되는 모든 서비스를 이용할 수 있습니다.

3. "비회원"이란 회원 가입 없이 "회사"가 제공하는 서비스를 제한적으로 이용하는 자를 말합니다.


제3조 회원 가입


1. "회원"이 되고자 하는 자는 "회사"가 정한 가입 양식에 따라 개인 정보를 기입하고 "등록하기" 단추를 누르는 방법으로 회원 가입을 신청합니다.

2. "회사"는 제1항과 같이 회원으로 가입할 것을 신청한 자가 다음 각 호에 해당하지 않는 한 신청한 자를 회원으로 등록합니다.
    ① 가입신청자가 본 약관 제6조 제3항에 의하여 이전에 회원자격을 상실 한 적이 있는 경우. 다만 제6조 제3항에 의한 회원자격 상실 후 3년이 경과한 자로서 "회사"의 회원재가입 승낙을 얻은 경우에는 예외로 합니다.
    ② 등록 내용에 허위, 기재누락, 오기가 있는 경우
    ③ 타 회원으로 등록하는 것이 "회사"의 기술상 현저히 지장이 있다고 판단되는 경우

3. 회원가입계약의 성립시기는 "회사"의 승낙이 가입신청자에게 도달한 시점으로 합니다.

4. "회원"은 제1항의 회원정보 기재 내용에 변경이 발생한 경우, 즉시 변경사항을 정정하여 기재하여야 합니다.


제4조 서비스의 제공 및 변경


1. "이용자"에게 아래와 같은 서비스를 제공합니다
    ① 연간회원권 등록 및 변경, 조회
    ② 고객지원(Q&A) 서비스
    ③ 기타 "회사"가 자체 개발하거나 다른 회사와의 협력계약 등을 통해 "이용자"들에게 제공할 일체의 서비스

2. 제1항의 서비스는 "비회원"에게는 제한적으로 제공될 수 있으며 제한된 "서비스"의 경우 "회원"들은 log-in 후 이용 가능합니다.

3. "회사"는 그 변경될 서비스의 내용 및 제공일자를 제7조 제2항에서 정한 방법으로 "이용자"에게 통지하고, 제1항에 정한 서비스를 변경하여 제공할 수 있습니다.


4. "회원"은 제1항의 회원정보 기재 내용에 변경이 발생한 경우, 즉시 변경사항을 정정하여 기재하여야 합니다.


제5조 서비스의 중단


1. "회사"는 컴퓨터 등 정보통신설비의 보수점검·교체 및 고장, 통신의 두절 등의 사유가 발생한 경우에는 서비스의 제공을 일시적으로 중단할 수 있고, 새로운 서비스로의 교체, 기타 "회사"가 적절하다고 판단하는 사유에 기하여 현재 제공되는 서비스를 완전히 중단할 수 있습니다.

2. 제1항에 의한 서비스 중단의 경우에는 "회사"는 제7조 제2항에서 정한 방법으로 이용자에게 통지합니다. 다만, "회사"가 통제할 수 없는 사유로 인한 서비스의 중단(시스템 관리자의 고의, 과실이 없는 디스크 장애, 시스템 다운 등)으로 인하여 사전 통지가 불가능한 경우에는 그러하지 아니합니다.


제6조 이용자 탈퇴 및 자격 상실 등


1. "회원"은 "회사"에 언제든지 자신의 회원 등록을 말소해 줄 것(회원 탈퇴)을 요청할 수 있으며 "회사"는 위 요청을 받은 즉시 해당 "회원"의 등록 말소를 위한 절차를 밟습니다.

2. "회원"이 다음 각 호의 사유에 해당하는 경우, "회사"는 회원자격을 적절한 방법으로 제한 및 정지, 상실시킬 수 있습니다.
    ① 가입 신청 시에 허위 내용을 등록한 경우
    ② 다른 사람의 "서비스" 이용을 방해하거나 그 정보를 도용하는 등 전자 거래질서를 위협하는 경우
    ③ "서비스"를 이용하여 법령과 본 약관이 금지하거나 공서양속에 반하는 행위를 하는 경우


제7조 이용자에 대한 통지


1. "회사"가 특정 이용자에 대한 통지를 하는 경우 "이용자"가 회원 가입 시 제공한 메일주소로 할 수 있습니다.

2. "회사"가 불특정다수 이용자에 대한 통지를 하는 경우 "사이트" 게시판에 게시함으로써 개별 통지에 갈음할 수 있습니다.


제8조 이용자의 개인정보보호


"회사"는 관련법령이 정하는 바에 따라서 이용자 등록정보를 포함한 "이용자"의 개인정보를 보호하기 위하여 노력합니다. "이용자"의 개인정보보호에 관해서는 관련법령 및 "회사"가 정하는 "개인정보취급방침"에 정한 바에 의합니다.


제9조 "회사"의 의무


1. "회사"는 법령과 본 약관이 금지하거나 공서양속에 반하는 행위를 하지 않으며 본 약관이 정하는 바에 따라 지속적이고, 안정적으로 서비스를 제공하기 위해서 노력합니다.

2. "회사"는 "이용자"가 안전하게 인터넷 서비스를 이용할 수 있도록 "이용자"의 개인정보 보호를 위한 보안 시스템을 구축합니다.

3. "회사"는 "이용자"가 원하지 않는 영리목적의 광고성 전자우편을 발송하지 않습니다.


제10조 이용자의 ID 및 비밀번호에 대한 의무


1. "회사"가 관계법령, "개인정보취급방침"에 의해서 그 책임을 지는 경우를 제외하고, 자신의 ID와 비밀번호에 관한 관리책임은 각 회원에게 있습니다.

2. "회원"은 자신의 ID 및 비밀번호를 제3자에게 이용하게 해서는 안됩니다.

3. "회원"은 자신의 ID 및 비밀번호를 도난 당하거나 제3자가 사용하고 있음을 인지한 경우에는 바로 "회사"에 통보하고 "회사"의 안내가 있는 경우에는 그에 따라야 합니다.


제11조 이용자의 의무


1. 이용자는 다음 각 호의 행위를 하여서는 안됩니다.
    ① 회원가입신청 또는 변경시 허위내용을 등록하는 행위
    ② "회사"에 게시된 정보를 변경하는 행위
    ③ “회사”, 기타 제3자의 인격권 또는 지적재산권을 침해하거나 업무를 방해하는 행위
    ④ 다른 회원의 ID를 도용하는 행위
    ⑤ 정크메일(junk mail), 스팸메일(spam mail), 행운의 편지(chain letters), 피라미드 조직에 가입할 것을 권유하는 메일, 외설 또는 폭력적인 메시지·화상·음성 등이 담긴 메일을 보내거나 기타 공서양속에 반하는 정보를 공개 또는 게시하는 행위
    ⑥ 관련 법령에 의하여 그 전송 또는 게시가 금지되는 정보(컴퓨터 프로그램 등)를 전송 또는 게시하는 행위
    ⑦ "회사"의 직원이나 "사이트" 서비스의 관리자를 가장하거나 사칭하여 또는 타인의 명의를 도용하여 글을 게시하거나 메일을 발송하는 행위
    ⑧ 컴퓨터 소프트웨어, 하드웨어, 전기통신 장비의 정상적인 가동을 방해, 파괴할 목적으로 고안된 소프트웨어 바이러스, 기타 다른 컴퓨터 코드, 파일, 프로그램을 포함하고 있는 자료를 게시하거나 전자우편으로 발송하는 행위
    ⑨ 스토킹(stalking) 등 다른 이용자를 괴롭히는 행위
    ⑩ 다른 이용자에 대한 개인정보를 그 동의 없이 수집, 저장, 공개하는 행위
    ⑪ 불특정 다수의 자를 대상으로 하여 광고 또는 선전을 게시하거나 스팸 메일을 전송하는 등의 방법으로 "사이트"의 서비스를 이용하여 영리 목적의 활동을 하는 행위
    ⑫ "회사"가 제공하는 서비스에 정한 약관, 기타 서비스 이용에 관한 규정을 위반하는 행위

2. 제1항에 해당하는 행위를 한 "이용자"가 있을 경우 "회사"는 본 약관 제6조 제2항, 제3항에서 정한 바에 따라 "이용자"의 회원자격을 적절한 방법으로 제한 및 정지, 상실시킬 수 있습니다.

3. "이용자"는 그 귀책사유로 인하여 "회사"나 다른 "이용자"가 입은 손해를 배상할 책임이 있습니다.


제12조 이용자의 의무


"이용자"의 공개게시물의 내용이 다음 각 호에 해당하는 경우 "회사"는 "이용자"에게 사전 통지 없이 해당 공개게시물을 삭제할 수 있고, 해당 "이용자"의 회원 자격을 제한, 정지 또는 상실시킬 수 있습니다.

1. 다른 이용자 또는 제3자를 비방하거나 중상 모략으로 명예를 손상시키는 내용

2. 공서양속에 위반되는 내용의 정보, 문장, 도형 등을 유포하는 내용

3. 범죄행위와 관련이 있다고 판단되는 내용

4. 다른 이용자 또는 제3자의 저작권 등 기타 권리를 침해하는 내용

5. 기타 관계 법령에 위배된다고 판단되는 내용


제13조 게시물에 대한 책임과 정책


"이용자"가 게시판 내에 게시한 게시물의 저작권은 게시자 본인에게 있으며, 본 게시판에 올린 정보나 의견은 "회사"의 입장과는 무관합니다.

게시판에 게시한 게시물로 파생되는 문제에 대해서는 전적으로 해당 게시물을 게시한 본인에게 책임이 있습니다. "회사"는 "이용자"가 게시판에 게시, 게재하거나 서비스를 통해 전송한 내용물에 대하여 책임이 없으며, 삭제 대상이 되는 게시물에 해당하는 경우에는 사전 통지 후 삭제할 수 있습니다.

단 게시물이 불법적인 내용이 확실할 경우 통보 없이도 삭제가 가능합니다. "이용자"가 게시한 게시물이 타인의 저작권, 프로그램 저작권 등을 침해하더라도 이에 대한 민, 형사상의 책임을 부담하지 않으며, 만일 이를 이유로 "회사"가 타인으로부터 손해배상청구 등 이의 제기를 받은 경우 해당 "이용자"는 그로 인해 발생한 모든 손해를 부담하여야 합니다.

1. "회사"는 "이용자"가 게시한 서비스 내의 모든 내용물이 게시판 운영원칙에 위배된다고 판단할 경우 해당 게시자에게 사전 또는 사후 통보 없이 삭제할 수 있으며, 더불어 해당 "이용자"에게는 그 경중에 따라 합당한 제재를 가할 수 있습니다.

2. "회사"는 필요에 의해 제공되는 카테고리 및 게시판의 추가 생성과 삭제를 임의로 할 수 있으며, 또한 게시판에 저장된 자료에 대해 게재기간 또는 저장기간을 정할 수 있고, 이를 변경할 수 있습니다.

3. "회사"는 필요에 따라 "이용자"가 게시한 게시물을 사전 통지 없이 편집, 이동할 수 있으며, "이용자"가 해지하거나 적법한 사유로 해지 된 경우 해당 "이용자"가 게시하였던 게시물을 삭제할 수 있습니다.


제14조 게시물 삭제기준/제재조치


'정보 통신 윤리 위원회 규칙'을 기본 원칙으로 하며 다음과 같은 내용의 게시물은 등록을 금합니다.

1. 현행법을 어기고 공공질서, 미풍양속을 저해하는 내용의 게시물
    - 국가이념과 국가의 존립을 훼손하고 반국가적 행위의 수행을 목적으로 하는 내용
    - 타인 또는 타 단체의 권리를 침해하거나 명예를 훼손하는 내용
    - 사회적 혼란을 야기시키는 허위 사실인 내용
    - 개인의 사생활을 침해하는 내용
    - 인명을 경시하고 폭력성이 짙은 내용 및 범죄 혹은 비행행위를 찬미, 조장하는 내용
    - 범죄행위의 구체적인 방법을 묘사하여 모방범죄를 유발하게 하는 내용
    - 보는 이에게 혐오감을 유발하는 내용과 정보
    - 성적인 욕구를 지나치게 자극하거나 혐오감을 주는 음란한 내용
    - 불륜관계, 근친상간 등 패륜적, 반인류적 성행위를 자세하게 소개하거나 흥미위주로 묘사한 내용
    - 성폭력, 강간, 윤간 등 성범죄를 구체적, 사실적으로 묘사하거나 미화한 내용
    - 성을 상품화하거나 특정 신체부위를 지나치게 노출 및 언급한 내용
    - 욕설 또는 언어 폭력 등의 저속한 표현으로 타인의 인격을 모독하거나 불쾌감 또는 혐오감을 불러 일으키는 내용
    - 특정 종교간의 감정 대립을 조장하는 내용
    - 미신 또는 비과학적인 생활태도를 조장하는 내용

2. 적절하지 못한 내용을 담은 게시물
    - 스팸성 글(저주성 글, 행운의 편지 등)
    - 특정 개인 신상 정보 노출로 인해 피해가 예상되는 경우
    - 근거 없는 내용을 게재함으로 인해 개인, 특히 공인의 사생활침해 및 명예 훼손의 소지가 있는 경우
    - 게시물의 내용이 게시판의 성격에 위배되거나 동일한 게시물을 여러 게시판에 등록한 경우
    - 지나치게 무성의, 무의미한 내용의 게시물
    - 버그 현상으로 인해 화면상에서 그 내용을 확인할 수 없는 게시물
    - 카테고리에 대한 주제와 무관하게 진행되는 논쟁으로 인해 게시판 이용에 혼란을 야기시키는 게시물
    - 관리자에 의해 삭제된 게시물을 전체 인용하는 경우
    - 매춘, 사이버섹스, 노골적인 성적대화 등 성적유희 대상을 찾거나 매개하는 내용
    - 음란 정보 또는 퇴폐업소가 있는 장소를 안내 또는 매개하는 내용
    - 특정 이용자, 개인을 감정적으로 비난하고 분쟁을 유도하는 내용의 게시물
    - 의료, 기구, 약품, 건강 보조 식품 등을 과장되게 소개하여 오용 또는 남용을 조장하는 내용을 담은 게시물
    - 출처가 불분명한 인용문(일명 퍼온글) 및 게시자가 책임지지 못하는 정보 및 주장을 담은 게시물
    - 정보통신설비의 오동작이나 정보 등의 파괴 및 혼란을 유발시키는 컴퓨터 바이러스 감염자료를 등록 또는 유포하는 행위

3. 저작권에 위반되는 내용의 게시물
    - 상용 프로그램의 등록과 게재, 배포를 안내하는 내용
    - 정품 확인이 안되는 소프트웨어, 각종 저작물의 유통을 담은 내용
    - 타인의 권리에 속하는 저작권, 상표권, 의장권 등을 무단으로 침해하는 내용

4. 온라인 판매/구매/돈벌기 관련 게재 금지 게시물
    - 돈벌기 사이트 관련 게시물
    - 특정 사이트 및 제품에 대한 직접적인 홍보 및 간접 홍보의 내용
    - 불법 게임, 소프트웨어, 음반, 영상의 복사 및 판매(백업CD 포함)의 내용

    - 음란, 폭력물을 판매할 목적으로 선전하는 내용
    - 미풍양속을 위반하고 사행심을 조장하는 영상 및 저작물
4. 기타
    - 타인의 ID를 도용해 부정하게 사용하는 경우
    - "회사"의 정상적인 경영활동 및 서비스를 방해하고 회사 이익에 막대한 지장과 해악을 미친다고 판단되는 게시물
    - "이용자"들에게 피해 및 손해를 입힐 우려가 있다고 판단되는 게시물
이상의 내용에 저촉되는 게시물 등에 대해서는 사전 통지 없이 임의 삭제될 수 있으며 위반사항이 거듭 되거나 위반으로 인한 피해가 극심하다고 판단되는 경우, "이용자"를 경고 또는 이용 중지 처리할 수 있습니다.


제15조 저작권의 귀속 및 이용제한


1. "사이트"와 관련한 자산은 저작권, 상표권, 기술에 대한 정보, 텍스트, 그래픽, 오디오, 비디오, 다운로드, 링크, 그리고 소스코드 (이하 웹사이트 서비스)이며, "회사"는"서비스" 대해 모든 권리를 가지고 있습니다. 모든 형태의 정보는 "이용자" 여러분들을 위한 것이며, 여러분들의 편의를 위해 제공되는 것입니다. 그러나, "회사"는 이러한 정보에 대한 상업적 사용권을 허락하는 것은 아님을 밝혀드립니다. "이용자"는 개인적인 용도가 아닌 어떠한 경우에도 이 "사이트" "서비스"를 사용할 수 없습니다.

2. 이용자는 "사이트"를 이용함으로써 얻은 정보를 "회사"의 사전승낙 없이 복제, 전송, 출판, 배포, 방송 기타 방법에 의하여 영리목적으로 이용하거나 제3자에게 이용하게 하여서는 안됩니다.


제16조 면책


1. "회사"는 "이용자"가 "서비스"를 이용함으로써 기대되는 수익을 얻지 못하거나 "서비스"를 통해 얻은 자료를 이용하여 발생한 손해에 대해서는 책임을 부담하지 않습니다.

2. "사이트"의 정보나 자료들은 증권거래에 관련된 기구들의 요구 조건을 충족 시키지 못함을 알려드립니다. 그러므로, 이러한 정보나 자료 등을 참조해 투자 결정을 내리지 마시기를 부탁드립니다. 이에 대해 "회사"는 명시적으로 이들 정보나 자료 등에 대해 상업, 금융 정보로서 정확성, 신뢰성에 대해 어떠한 보증도 할 수 없음을 알려드립니다.

3. "회사"는 자체적인 기준에 의거해 다양한 링크를 제공하고 있습니다. 링크된 웹사이트들은 모두 "이용자"들의 정보획득과 편의를 위해 제공하고 있으나 링크 사이트에 대한 어떤 법적 책임도 "회사"에는 있지 않으며 웹사이트의 신뢰성에 대한 보장을 "회사"가 하지는 않습니다. 각 링크 사이트는 "이용자" 여러분께서 판단하시어 효율적으로 이용하시기 바랍니다.

4. "이용자"가 화면에 게재한 정보, 자료, 사실 등의 내용에 관한 신뢰도 또는 정확성에 대하여는 해당 "이용자"가 책임을 부담하며, "회사"는 내용의 부정확 또는 허위로 인해 "이용자" 또는 제3자에게 발생한 손해에 대하여는 아무런 책임을 부담하지 않습니다.

5. "회사"는 "서비스" 이용과 관련하여 "이용자"의 고의 또는 과실로 인하여 "이용자" 또는 제3자에게 발생한 손해에 대하여는 아무런 책임을 부담하지 않습니다.


제17조 약관의 개정


1. "회사"는 약관의 규제 등에 관한 법률, 전자거래기본법, 전자서명법, 정보통신망 이용촉진 등에 관한 법률 등 관련법을 위배하지 않는 범위에서 본 약관을 개정할 수 있습니다.

2. "회사"가 본 약관을 개정할 경우에는 적용일자 및 개정사유를 명시하여 현행약관과 함께 초기화면에 그 적용일자 칠(7)일 이전부터 적용일자 전일까지 공지합니다.

3. "이용자"는 변경된 약관에 대해 거부할 권리가 있습니다. "이용자"는 변경된 약관이 공지된 후 십오(15)일 이내에 거부의사를 표명할 수 있습니다. "이용자"가 거부하는 경우 "회사"는 당해 "이용자"와의 계약을 해지할 수 있습니다. 만약 "이용자"가 변경된 약관이 공지된 후 십오(15)일 이내에 거부의사를 표시하지 않는 경우에는 동의하는 것으로 간주합니다.


제18조 재판관할


"회사"와 "이용자" 간에 발생한 서비스 이용에 관한 분쟁에 대하여는 대한민국 법을 적용하며, 본 분쟁으로 인한 소는 민사소송법상의 관할을 가지는 대한민국의 법원에 제기합니다.


부칙


본약관은 2017년 3월 1부터 적용됩니다.
2005년 6월 10일부터 시행되던 종전의 약관은 본 약관으로 대체합니다.
</pre>    
    `,
    name: 'termsAgree',
    agree: null,
    required: true
  }, {
    title: '개인정보 수집 및 이용에 대한 안내 (필수)',
    desc : `
<pre>
정보통신망법 규정에 따라 전남드래곤즈 홈페이지에 회원가입 신청하시는 분께 수집하는 개인정보의 항목, 개인정보의 수집 및 이용목적, 개인정보의 보유 및 이용기간을 안내 드리오니 자세히 읽은 후 동의하여 주시기 바랍니다.


□ 개인정보의 수집 및 이용 동의
㈜전남드래곤즈는 귀하께서 전남드래곤즈 홈페이지(www.dragons.co.kr)의 이용약관의 내용에 대해 「동의한다」 버튼 또는 「동의하지 않는다」 버튼을 클릭할 수 있는 절차를 마련하여, 「동의한다」 버튼을 클릭하면 개인정보 수집에 대해 동의한 것으로 간주합니다.


전남드래곤즈 홈페이지는 회원가입 시 서비스 이용을 위해 필요한 최소한의 개인정보만을 수집합니다. 처리하고 있는 개인정보는 다음의 목적 이외의 용도로는 이용되지 않으며, 이용 목적이 변경되는 경우에는 개인정보 보호법 제18조에 따라 별도의 동의를 받는 등 필요한 조치를 이행 할 예정입니다.


회원가입 시점에 전남드래곤즈가 이용자로부터 수집하는 개인정보는 아래와 같습니다.
- 회원 가입 시에 ‘이름, 아이디, 비밀번호, 핸드폰번호, 이메일주소, 회원인증을 통한 생년월일, 성별, 암호화된 이용자 확인값(CI), 중복가입확인정보(DI)’를 필수항목으로 수집합니다.


개인정보 항목별 구체적인 수집목적 및 이용목적은 다음과 같습니다.
- 이름, 아이디, 비밀번호, 생년월일, 성별, 암호화된 이용자 확인값(CI), 중복가입확인정보(DI) : 회원제 서비스 이용에 따른 본인 식별 절차에 이용

- 이메일주소, 핸드폰번호 : 공지사항 전달, 개인맞춤 서비스, 경품 배송 등을 위한 원활한 의사소통 경로의 확보 등의 안내


□ 수집하는 개인정보 항목
① 필수 개인정보 항목 : 이름, 아이디, 비밀번호, 핸드폰번호, 이메일주소, 회원인증을 통한 생년월일, 성별, 암호화된 이용자 확인값(CI), 중복가입확인정보(DI)

② 선택 개인정보 항목 : 없음


□ 개인정보의 보유기간 및 이용기간
전남드래곤즈 홈페이지는 수집된 개인정의 보유기간은 회원가입 하신후 회원탈퇴 시 지체없이 파기됩니다. 또한 해지시 전남드래곤즈 홈페이지는 회원님의 개인정보를 재생이 불가능한 방법으로 즉시 파기합니다(개인정보가 제3자에게 제공된 경우에는 제3자에게도 파기하도록 지시합니다.). 다만, 다음 각호의 경우에는 각 호에 명시한 기간동안 개인정보를 보유합니다.


① 상법 등 법령의 규정에 의하여 보존할 필요성이 있는 경우에는 법령에서 규정한 보존기간 동안 거래내역과 최소한의 기본정보를 보유함

② 보유기간을 회원님에게 미리 고지하고 그 보유기간이 경과하지 아니한 경우와 개별적으로 회원님의 동의를 받을 경우에는 약속한 보유기간 동안 보유함


□ 동의 거부 권리 및 동의 거부 시 불이익 내용
전남드래곤즈 홈페이지 이용을 위해 필요한 최소한의 개인정보이므로 동의를 해 주셔야 서비스 이용이 가능합니다. 귀하는 개인정보의 수집목적 및 이용목적에 대한 동의를 거부할 수 있으며, 동의 거부시 전남드래곤즈 홈페이지에 회원가입이 되지 않으며, 전남드래곤즈 홈페이지에서 제공하는 제한적인 서비스(쇼핑몰, 원정버스, 시즌권등록)를 이용할 수 없습니다.


</pre>    
    `,
    name: 'privacyAgree',
    agree: null,
    required: true
  }, {
    title: '개인정보 처리위탁 안내 (필수)',
    desc : `
<pre>
(주)전남드래곤즈(이후 "회사")는 개인정보를 개인정보처리방침에서 고지한 개인정보 처리위탁(제3자 제공) 범위 내에서 제공하며, 정보 주체의 사전 동의없이 범위를 초과하여 위탁 혹은 제3자에게 제공하지 않습니다.


<홈페이지>
- 수탁업체 : ㈜플랫폼엔
- 제공목적 : 홈페이지 서비스 운영 및 관리
- 제공항목 : 이름, 아이디, 비밀번호, 핸드폰번호, 이메일주소, 회원인증을 통한 생년월일, 성별, 암호화된 이용자 확인값(CI), 중복가입확인정보(DI)
- 개인정보의 보유 및 이용기간 : 회원 탈퇴시 혹은 위탁계약 종료시까지


<티켓>
- 수탁업체 : 주식회사 엔에치앤티켓링크
- 제공목적 : 시즌권 및 티켓예매 및 확인, 취소
- 제공항목 : 이름, 휴대폰번호, 생년월일
- 개인정보의 보유 및 이용기간 : 회원 탈퇴시 혹은 위탁계약 종료시까지



※ 개인정보 제공에 대한 동의를 거부할 권리가 있으며, 동의를 거부할 경우 홈페이지를 이용 하실 수 없습니다.
</pre>    
    `,
    name: 'privacyOutsourcingAgree',
    agree: null,
    required: true
  }, {
    title: '개인정보의 마케팅 활용 및 광고성 메시지 수신 동의(선택)',
    desc : `
<pre>
회사는 다음과 같이 귀하의 개인정보를 수집 및 이용 합니다.

1. 개인정보의 수집 및 이용 목적
- 구단 소식 및 경기 정보 안내, 이벤트, 홍보, 프로모션 정보 등 전자적 전송매체를 이용한 광고성 정보 전송

2. 수집하는 개인정보의 항목
- 아이디, 회원명, 핸드폰번호

3. 개인정보의 보유 및 이용기간
- 수신 거부 혹은 회원 탈퇴시까지
  
4. 동의를 거부할 권 리 및 동의 거부시 불이익 사항
귀하는 본 개인정보의 수집 및 이용에 대한 동의를 거부할 권리가 있으며, 동의를 거부하더라도 별도의 불이익 사항은 없습니다.
</pre>    
    `,
    name: 'adMsgAgree',
    agree: null,
    required: false
  }
]
